import { DataGridPremiumProps, GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { inventoryCheckService } from 'shared/services';
import InventoryCheckDetailPanel from '../components/InventoryCheckDetailPanel';
import { InventoryCheckColumns } from '../inventory-check';
import { InventoryCheckArchiveColumns } from '../inventory-check-archive';

export const InventoryCheckArchive = () => {
  const translationPrefix = 'pages.inventory-check-archive';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const aggregatedColumns: GridColDef[] = InventoryCheckArchiveColumns(
    inventoryCheckService,
    datagridRefresh
  );

  const columns: GridColDef[] = InventoryCheckColumns();

  const getDetailPanelContent = useCallback<
    NonNullable<DataGridPremiumProps['getDetailPanelContent']>
  >(({ row }) => <InventoryCheckDetailPanel row={{ ...row }} columns={columns} />, [columns]);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={aggregatedColumns}
        service={inventoryCheckService}
        getMethod={inventoryCheckService.getArchived}
        refresh={datagridRefresh}
        getDetailPanelContent={getDetailPanelContent}
      />
    </TenantPage>
  );
};

export default InventoryCheckArchive;
